export const baseUrl = 'https://api.slmonitoreo.com/sl/';
//export const baseUrl = 'http://localhost:8050/sl/';
export const GOOGLE_API_KEY = 'AIzaSyA_D1tWSkoVndYfLKH3w_uwLPwXiqvGjwo';

export const alerta = {
  type: 'dark',
  title: 'Alerta',
  message: 'Mensaje de alerta',
  timer: 0,
};